import Duck, { Selector } from 'extensible-duck';
import { getLocalStorageToken } from './localStorage';

const storeKey = 'jwt';
const namespace = 'token';

const emptyToken = {
  token: null,
  refreshToken: null,
  expires: null,
};

const duck = new Duck({
  namespace,
  store: storeKey,
  types: ['TOKEN_REFRESH_FAILED', 'TOKEN_REFRESH_SUCCESS', 'CLEAR_TOKEN', 'SET_TOKEN', 'SET_INVALID_ROLES'],
  initialState: {
    ...(getLocalStorageToken() || emptyToken),
    invalidRoles: false,
    error: null,
  },
  reducer: (state, action, { types: typesInput, initialState }) => {
    switch (action.type) {
      case typesInput.SET_TOKEN:
      case typesInput.TOKEN_REFRESH_SUCCESS:
        return {
          ...initialState,
          token: action.token,
          refreshToken: action.refreshToken,
          expires: action.expires,
        };
      case typesInput.TOKEN_REFRESH_FAILED:
        return {
          ...initialState,
          ...emptyToken,
          error: action.error,
        };

      case typesInput.CLEAR_TOKEN:
        return {
          ...initialState,
          ...emptyToken,
        };

      case typesInput.SET_INVALID_ROLES:
        return {
          ...initialState,
          ...emptyToken,
          invalidRoles: true,
        };

      default:
        return state;
    }
  },
  selectors: {
    root: state => state[namespace][storeKey],
    token: new Selector(selectorsInput => state => selectorsInput.root(state).token),
    refreshToken: new Selector(selectorsInput => state => selectorsInput.root(state).refreshToken),
    expires: new Selector(selectorsInput => state => selectorsInput.root(state).expires),
    tokenObject: new Selector(selectorsInput => state => ({
      token: selectorsInput.token(state),
      refreshToken: selectorsInput.refreshToken(state),
      expires: selectorsInput.expires(state),
    })),
    error: new Selector(selectorsInput => state => selectorsInput.root(state).error),
    invalidRoles: new Selector(selectorsInput => state => selectorsInput.root(state).invalidRoles),
  },
  creators: ({ types: typesInput }) => ({
    tokenRefreshSuccess: (token, refreshToken, expires) => ({
      type: typesInput.TOKEN_REFRESH_SUCCESS,
      token,
      refreshToken,
      expires,
    }),
    tokenRefreshFailed: error => ({ type: typesInput.TOKEN_REFRESH_FAILED, error: error.message }),
    clearToken: () => ({ type: typesInput.CLEAR_TOKEN }),
    setToken: (token, refreshToken, expires) => ({ type: typesInput.SET_TOKEN, token, refreshToken, expires }),
    setInvalidRoles: () => ({ type: typesInput.SET_INVALID_ROLES }),
  }),
});

export { duck as default, namespace, storeKey };
export const { creators, reducer, types, selectors } = duck;
